import React from "react"
import { getStaticFile } from "utils/getStaticFile"
import { Image } from "../../../ui-shared/components/Image/Image"
import { productCardImage } from "./ProductCard.css"
import type { ProductCardDataType } from "./types"

type Props = {
  altOverride?: string
  product: Pick<ProductCardDataType, "image" | "brandName">
}

export const ProductCardImage: React.FC<Props> = ({ altOverride, product }) => {
  return (
    <div className={productCardImage}>
      <Image
        // use placeholder image if no image is available
        src={product.image.src || getStaticFile("/images/placeholder.svg")}
        alt={altOverride ?? product.image.alt ?? product.brandName ?? ""}
        variant="square"
      />
    </div>
  )
}
